<template>
  <div class="etms-router-body">
    <el-tabs v-model="activepan" type="card" @tab-click="handleClick">
      <el-tab-pane label="平台发货商" name="platform">
        <div class="pane-content">
          <div class="etms-router-search">
            <el-input size="mini" placeholder="请选择发货商搜索" class="etms-router-search-element">
            </el-input>
          </div>
          <div v-for="item in shippers" :key="item.value" class="list">
            <div :class="[item.showstate?'shipper-list-radius':'','shipper-list']" @click="item.showstate=!item.showstate">
              <div class="title fl">
                <el-tooltip class="item" effect="dark" :content="item.label" placement="top">
                  <span>{{item.label}}</span>
                </el-tooltip>
              </div>
              <div class="describe fl">
                <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                  <span>{{item.describe}}</span>
                </el-tooltip>
              </div>

              <div class="check fr">
                <el-checkbox v-model="item.checked" @change="shipperChange(item)">启用</el-checkbox>
              </div>
              <div class="contact fr">
                <a class="qq" v-for="qq in item.serviceqq" :key="qq" target="_blank" v-bind:href="'http://wpa.qq.com/msgrd?v=3&uin='+qq+'&site=qq&menu=yes'">
                  <img border="0" src="/static/qq_talk.gif" alt="点击这里给我发消息" title="点击这里给我发消息">
                </a>
              </div>
            </div>
            <div v-for="channel in item.channels" :key="channel.val" class="channel-list" v-show="item.showstate">
              <div class="title fl">{{channel.label}}</div>
              <div class="describe fl">
                <el-tooltip class="item" effect="dark" :content="channel.describe" placement="top">
                  <span>{{channel.describe}}</span>
                </el-tooltip>
              </div>
              <div class="check fr">
                <el-checkbox v-model="channel.checked" @change="channelChange(item)">启用</el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="第三方发货商" name="thirdparty">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activepan: 'platform',
      shippers: [
        {
          label: '广州凯捷物流供应链',
          value: '0',
          describe: '揽收城市:广州、深圳、珠海、佛山、东莞、中山、清远、肇庆、惠州',
          serviceqq: ['328582223', '447123891'],
          checked: false,
          showstate: false,
          channels: [
            { label: '广州小包', value: '', describe: '预计时效:7-30天,可到美国、英国、俄罗斯、加拿大等国家;只接收2KG以内件;包裹类型只可为文件和物品;不可走粉末、气体、液体、膏体、违禁品等！', checked: false },
            { label: '深圳小包', value: '', describe: '预计时效:7-30天,可到美国、英国、俄罗斯、加拿大等国家;只接收2KG以内件;包裹类型只可为文件和物品;不可走粉末、气体、液体、膏体、违禁品等！', checked: false }
          ]
        },
        {
          label: '广州腾汇国际物流',
          value: '1',
          describe: '',
          serviceqq: ['328582223', '447123891'],
          checked: false,
          showstate: false,
          channels: [
            { label: 'pony专线', value: '', describe: '预计时效:7-30天,只到俄罗斯;只接收2KG以内件;包裹类型只可为文件和物品;不可走粉末、气体、液体、膏体、违禁品等！', checked: false },
            { label: '深圳小包', value: '', describe: '预计时效:7-30天,可到美国、英国、俄罗斯、加拿大等国家;只接收2KG以内件;包裹类型只可为文件和物品;不可走粉末、气体、液体、膏体、违禁品等！', checked: false }
          ]
        },
        {
          label: '深圳尚方国际物流',
          value: '2',
          describe: '',
          serviceqq: ['328582223', '447123891'],
          checked: false,
          showstate: false,
          channels: [
            { label: '深圳DHL', value: '', describe: '预计时效:5-15天;300公斤以内;可到美国、英国、俄罗斯、加拿大等国家;包裹类型只可为文件和物品;不可走粉末、气体、液体、膏体、违禁品等！', checked: false },
            { label: '香港DHL', value: '', describe: '预计时效:5-15天;300公斤以内;可到美国、英国、俄罗斯、加拿大等国家;包裹类型只可为文件和物品;不可走粉末、气体、液体、膏体、违禁品等！', checked: false }
          ]
        }
      ],
    }
  },
  methods: {
    shipperChange (row) {
      if (!row.checked) {
        row.channels.forEach((item, index) => {
          item.checked = false
        })
      }
    },
    channelChange (row) {
      row.channels.forEach((item, index) => {
        if (item.checked) {
          row.checked = true
          return
        }
      })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.pane-content .list {
  width: 100%;
}

.pane-content .shipper-list {
  background-color: #dff0d8;
  margin: 10px 0;
  height: 35px;
  line-height: 35px;
  cursor: pointer;
  color: #3c763d;
  font-weight: 700;
  clear: both;
  display: block;
  border-radius: 6px;
}

.pane-content .shipper-list-radius {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.pane-content .shipper-list .title,
.pane-content .channel-list .title {
  padding-left: 10px;
  width: 20%;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pane-content .shipper-list .contact {
  text-align: right;
}

.pane-content .contact a {
  text-align: right;
  padding: 0 5px;
  line-height: 35px;
  vertical-align: middle;
}

.pane-content .contact a > img {
  padding-top: 7px;
}

.pane-content .shipper-list .describe,
.pane-content .channel-list .describe {
  width: 40%;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.pane-content .shipper-list .check,
.pane-content .channel-list .check {
  padding-right: 10px;
}

.channel-list {
  width: 100%;
  background-color: #f2f2f2;
  margin-top: -20px;
  height: 35px;
  line-height: 35px;
  clear: both;
  font-size: 12px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/ctms/deliver_setting.vue